<template>
	<div class="configuration">
		<div class="tab-title"
			:style="`color:${$appColors.primary}`"
		>{{select.name}}</div>
		<div>
			<v-tabs 
				v-model="localActive" 
				slider-color="primary" 
				right
				@change="$emit('change-tab', localActive)">
				<v-tab>
					Seleccionar Encuesta
				</v-tab>
				<v-tab>
					Asignar Áreas
				</v-tab>
				<v-tab-item>
					<polls 
						:polls="pollsArray"
						:poll-id="select.pollId"
						@select-poll="selectPoll"
						/>
				</v-tab-item>
				<v-tab-item>
					<areas
						:select="select"
						@update-total="updateTotal"
						@validate-value="validateValue"
						@select-areas-employees="selectAreasEmployees"
					/>
				</v-tab-item>
			</v-tabs>
		</div>
	</div>
</template>
<script>
import polls from '@/components/diagnosis/tab-poll';
import areas from '@/components/diagnosis/tab-areas';

function selectAreasEmployees(toolObject) {
	this.$emit('select-areas-employees', toolObject);
}

function data() {
	return {
		items: ['Seleccionar Encuesta', 'Asignar Áreas'],
		localActive: 0,
	};
}

function active(value) {
	this.localActive = value;
}

function updateTotal(value) {
	this.$emit('value-total', value);
}

function selectPoll(value) {
	this.$emit('select-poll', value);
}

function changeInput(value, index) {
	this.$emit('change-input', value, index);
}

function validateValue(value) {
	this.$emit('validate-value', value);
}

export default {
	name: 'configuration',
	data,
	components: {
		polls,
		areas,
	},
	methods: {
		changeInput,
		updateTotal,
		selectAreasEmployees,
		selectPoll,
		validateValue,
	},
	props: {
		pollsArray: {
			type: Array,
			default: () => [],
		},
		active: Number,
		select: {
			type: Object,
			default: () => {},
		},
	},
	watch: {
		active,
	},
};
</script>
<style lang="scss">
	.configuration {
		.tab-title {
			border-bottom: 1px solid map-get($colors, gray-slider);
			font-family: map-get($fonts, bold);
			font-size: map-get($sizes, medium);
			margin: 0 9px;
			padding-bottom: 12px;
			text-align: center;
			text-transform: uppercase;
		}

		.v-tabs__item {
			font-size: 11px;

			&.v-tabs__item--active {
				font-family: map-get($fonts, bold);
			}	
		}

		.v-tabs__container {
			border-bottom: 1px solid map-get($colors, gray-slider);
		}
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/configuration.vue